const PROMPT_REJECTED_MESSAGE =
  'Your prompt was rejected by the safety system. Please revise it and try again.';
const IMAGE_REJECTED_MESSAGE =
  'Your image was rejected by the safety system. Please upload a different image.';

export const IMAGE_CONTENT_POLICY_DELAY_MS = 60_000;
export const VIDEO_CONTENT_POLICY_DELAY_MS = 4 * 60_000;

export function isContentPolicyRejection(message: string): boolean {
  return (
    message === PROMPT_REJECTED_MESSAGE || message === IMAGE_REJECTED_MESSAGE
  );
}
